(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oracura-essentials"] && !Shopify.designMode) return;
  try {
    
  /**
   * Fills "Add The Essentials".
   *
   * One request per seed product, all in flight together but read back in
   * order, so the first product's accessories lead. A seed that fails is
   * skipped rather than emptying the row — on a collection page the other two
   * still have something to say.
   */
  (() => {
    for (const root of document.querySelectorAll('[data-essentials]')) {
      const row = root.querySelector('[data-essentials-row]');
      const ids = (root.dataset.seedIds || '').split(',').filter(Boolean);
      if (!row || !ids.length) continue;

      const limit = Number(root.dataset.limit) || 8;
      const base = window.Shopify?.routes?.root || '/';
      // Seeded with what the page already lists, so nothing is suggested twice.
      const seen = new Set((root.dataset.shownIds || '').split(',').filter(Boolean));

      const ask = (id) =>
        fetch(
          `${base}recommendations/products?section_id=${encodeURIComponent(root.dataset.sectionId)}` +
            `&product_id=${encodeURIComponent(id)}&intent=complementary&limit=${limit}`
        )
          .then((res) => (res.ok ? res.text() : ''))
          .catch(() => '');

      Promise.all(ids.map(ask)).then((pages) => {
        const parser = new DOMParser();
        let added = 0;

        for (const html of pages) {
          if (!html || added >= limit) continue;
          for (const card of parser.parseFromString(html, 'text/html').querySelectorAll('[data-essentials-card]')) {
            const id = card.dataset.productId;
            if (seen.has(id)) continue;
            seen.add(id);
            row.append(card);
            if ((added += 1) >= limit) break;
          }
        }

        if (added > 0) root.hidden = false;
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oracura-floating-button"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('oracura-draggable-chat')) {
    customElements.define('oracura-draggable-chat', class extends HTMLElement {
      connectedCallback() {
        const link = this.querySelector('a');
        if (!link) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const key = 'oracura-chat-position';
        let side = 'right';
        let fraction = 1;
        let gesture = null;
        let suppressClick = false;
        const bounds = () => {
          const size = link.offsetWidth;
          const inset = Math.max(12, parseFloat(getComputedStyle(link).getPropertyValue('--fab-right')) || 0);
          return { left: inset, right: Math.max(inset, innerWidth - size - inset), top: 12, bottom: Math.max(12, innerHeight - size - 12) };
        };
        const clamp = (value, min, max) => Math.min(max, Math.max(min, value));
        const place = (x, y) => {
          link.style.left = `${x}px`;
          link.style.top = `${y}px`;
          link.style.right = 'auto';
          link.style.bottom = 'auto';
        };
        const snap = () => {
          const area = bounds();
          place(area[side], area.top + fraction * (area.bottom - area.top));
        };
        const save = () => {
          try { localStorage.setItem(key, JSON.stringify({ side, fraction })); } catch {}
        };
        const initial = link.getBoundingClientRect();
        const area = bounds();
        fraction = clamp((initial.top - area.top) / Math.max(1, area.bottom - area.top), 0, 1);
        try {
          const saved = JSON.parse(localStorage.getItem(key));
          if (saved && ['left', 'right'].includes(saved.side) && Number.isFinite(saved.fraction)) {
            side = saved.side;
            fraction = clamp(saved.fraction, 0, 1);
          }
        } catch {}
        snap();
        link.addEventListener('dragstart', event => event.preventDefault(), options);
        link.addEventListener('pointerdown', event => {
          if (!event.isPrimary || event.button !== 0) return;
          suppressClick = false;
          const rect = link.getBoundingClientRect();
          gesture = { id: event.pointerId, x: event.clientX, y: event.clientY, left: rect.left, top: rect.top, moved: false };
          link.setPointerCapture(event.pointerId);
        }, options);
        link.addEventListener('pointermove', event => {
          if (!gesture || event.pointerId !== gesture.id) return;
          const dx = event.clientX - gesture.x;
          const dy = event.clientY - gesture.y;
          if (!gesture.moved && Math.hypot(dx, dy) < 8) return;
          gesture.moved = true;
          link.setAttribute('data-dragging', '');
          const area = bounds();
          place(clamp(gesture.left + dx, area.left, area.right), clamp(gesture.top + dy, area.top, area.bottom));
        }, options);
        const finish = event => {
          if (!gesture || event.pointerId !== gesture.id) return;
          if (gesture.moved) {
            const rect = link.getBoundingClientRect();
            const area = bounds();
            side = rect.left + rect.width / 2 < innerWidth / 2 ? 'left' : 'right';
            fraction = clamp((rect.top - area.top) / Math.max(1, area.bottom - area.top), 0, 1);
            suppressClick = true;
            snap();
            save();
          }
          gesture = null;
          link.removeAttribute('data-dragging');
          if (link.hasPointerCapture(event.pointerId)) link.releasePointerCapture(event.pointerId);
        };
        link.addEventListener('pointerup', finish, options);
        link.addEventListener('pointercancel', finish, options);
        link.addEventListener('lostpointercapture', finish, options);
        link.addEventListener('click', event => {
          if (suppressClick && event.detail !== 0) {
            event.preventDefault();
            event.stopImmediatePropagation();
          }
          suppressClick = false;
        }, { ...options, capture: true });
        link.addEventListener('keydown', event => {
          if (!['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].includes(event.key)) return;
          event.preventDefault();
          if (event.key === 'ArrowLeft') side = 'left';
          if (event.key === 'ArrowRight') side = 'right';
          const area = bounds();
          if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
            fraction = clamp(fraction + (event.key === 'ArrowUp' ? -24 : 24) / Math.max(1, area.bottom - area.top), 0, 1);
          }
          snap();
          save();
        }, options);
        window.addEventListener('resize', snap, options);
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oracura-how-to-use"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('oracura-guide-carousel')) {
    customElements.define('oracura-guide-carousel', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const { signal } = this.controller;
        const row = this.querySelector('.oracura-htu__row');
        const controls = this.querySelector('.oracura-htu__controls');
        const dots = this.querySelector('.oracura-htu__dots');
        const prev = this.querySelector('[data-guide-prev]');
        const next = this.querySelector('[data-guide-next]');
        if (!row || !controls) return;
        let positions = [];
        let active = 0;
        const sync = () => {
          active = positions.reduce((best, position, index) =>
            Math.abs(position - row.scrollLeft) < Math.abs(positions[best] - row.scrollLeft) ? index : best, 0);
          prev.disabled = active === 0;
          next.disabled = active === positions.length - 1;
          [...dots.children].forEach((dot, index) => dot.setAttribute('aria-current', String(index === active)));
        };
        const move = (index) => row.scrollTo({
          left: positions[Math.max(0, Math.min(index, positions.length - 1))],
          behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',
        });
        const resize = () => {
          const max = Math.max(0, row.scrollWidth - row.clientWidth);
          const start = row.firstElementChild?.getBoundingClientRect().left || 0;
          positions = [...new Set([...row.children].map(card =>
            Math.round(Math.min(max, card.getBoundingClientRect().left - start))))];
          dots.replaceChildren(...positions.map((_, index) => {
            const dot = document.createElement('button');
            dot.type = 'button';
            dot.setAttribute('aria-label', `Show guide page ${index + 1}`);
            dot.addEventListener('click', () => move(index));
            return dot;
          }));
          controls.hidden = max < 2;
          sync();
        };
        prev.addEventListener('click', () => move(active - 1), { signal });
        next.addEventListener('click', () => move(active + 1), { signal });
        row.addEventListener('scroll', sync, { passive: true, signal });
        this.observer = new ResizeObserver(resize);
        this.observer.observe(row);
        resize();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oracura-jump-to-top"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('oracura-jump-top')) {
    customElements.define(
      'oracura-jump-top',
      class extends HTMLElement {
        connectedCallback() {
          const button = this.querySelector('button');
          if (!button) return;
          this.controller = new AbortController();
          const options = { signal: this.controller.signal };
          const threshold = Number(this.dataset.threshold) || 400;

          // The page scrolls inside .page-wrapper on desktop and on the
          // document on phones, so ask whichever is actually scrolling rather
          // than assuming one of them. Asked again each time: on load the
          // wrapper may not yet be taller than the screen, and a choice made
          // then left the button never showing once it was.
          const wrapper = document.querySelector('.page-wrapper');
          const scrollerNow = () => (wrapper && wrapper.scrollHeight > wrapper.clientHeight + 8 ? wrapper : null);
          const offset = () => {
            const scroller = scrollerNow();
            return scroller ? scroller.scrollTop : window.scrollY || document.documentElement.scrollTop;
          };

          const update = () => {
            const past = offset() > threshold;
            // `hidden` keeps it out of the tab order when it is not offered;
            // the attribute below drives the fade.
            this.hidden = !past;
            if (past) this.setAttribute('data-visible', '');
            else this.removeAttribute('data-visible');
          };

          // Captured on the document, so it hears either scroller.
          document.addEventListener('scroll', update, { passive: true, capture: true, ...options });
          window.addEventListener('resize', update, { passive: true, ...options });

          button.addEventListener(
            'click',
            () => {
              const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
              const behavior = reduced ? 'instant' : 'smooth';
              const scroller = scrollerNow();
              if (scroller) scroller.scrollTo({ top: 0, behavior });
              else window.scrollTo({ top: 0, behavior });
              // Send the reader back to the start of the document as well as
              // the top of the page, so the next Tab continues from there
              // rather than from the button in the corner.
              const main = document.querySelector('#MainContent, main');
              if (main) {
                main.setAttribute('tabindex', '-1');
                main.focus({ preventScroll: true });
              }
            },
            options
          );

          update();
        }

        disconnectedCallback() {
          this.controller?.abort();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oracura-product-related"] && !Shopify.designMode) return;
  try {
    
  /* Store format without trailing zeros, `₹ 1,23,456`: ₹ + space, Indian
     digit grouping, paise only when there are some — the same shape Liquid's
     `| money_without_trailing_zeros` renders server-side, so a card built here
     does not sit next to one shaped differently. */
  const brandRelatedMoney = (cents) =>
    '₹ ' +
    (Number(cents) / 100).toLocaleString('en-IN', {
      minimumFractionDigits: Number(cents) % 100 ? 2 : 0,
      maximumFractionDigits: 2,
    });

  document.querySelectorAll('.oracura-related').forEach((root) => {
    const setupArrows = (row) => {
      if (row.parentElement.classList.contains('oracura-related__carousel')) return;
      const wrapper = document.createElement('div');
      wrapper.className = 'oracura-related__carousel';
      row.before(wrapper);
      wrapper.append(row);
      const buttons = [-1, 1].map(direction => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'oracura-related__arrow';
        button.dataset.direction = direction;
        button.textContent = direction < 0 ? '←' : '→';
        button.setAttribute('aria-label', direction < 0 ? 'Previous products' : 'Next products');
        button.addEventListener('click', () => {
          const step = row.firstElementChild?.getBoundingClientRect().width || row.clientWidth;
          const gap = parseFloat(getComputedStyle(row).columnGap) || 0;
          row.scrollBy({ left: direction * (step + gap), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        });
        wrapper.append(button);
        return button;
      });
      const sync = () => {
        const max = row.scrollWidth - row.clientWidth;
        buttons.forEach(button => { button.hidden = max < 2; });
        buttons[0].disabled = row.scrollLeft < 2;
        buttons[1].disabled = row.scrollLeft >= max - 2;
      };
      row.addEventListener('scroll', sync, { passive: true });
      const observer = new ResizeObserver(sync);
      observer.observe(row);
      sync();
      document.addEventListener('shopify:section:unload', event => {
        if (event.target.contains(root)) observer.disconnect();
      }, { once: true });
    };
    root.querySelectorAll('.oracura-related__list:not([data-recs-row])').forEach(setupArrows);
    const el = (tag, cls, text) => {
      const n = document.createElement(tag);
      if (cls) n.className = cls;
      if (text != null) n.textContent = text;
      return n;
    };

    const buildCard = (rec) => {
      const { mrpLabel, saleSuffix, addLabel, soldoutLabel, fromLabel } = root.dataset;
      const card = el('div', 'oracura-related__card');
      const link = el('a', 'oracura-related__link');
      link.href = rec.url;

      const photo = el('span', 'oracura-related__photo');
      if (rec.featured_image) {
        const img = el('img', 'oracura-related__img');
        const imageURL = new URL(rec.featured_image, location.href);
        if (imageURL.hostname.endsWith('.shopify.com')) imageURL.protocol = 'https:';
        imageURL.searchParams.set('width', '650');
        img.src = imageURL.href;
        img.loading = 'lazy';
        img.alt = rec.title;
        photo.appendChild(img);
      }
      const onSale = rec.compare_at_price && rec.compare_at_price > rec.price;
      if (onSale) {
        // Rounded, as the cart rounds it (snippets/oracura-pdp-related-card).
        const pct = Math.round(((rec.compare_at_price - rec.price) * 100) / rec.compare_at_price);
        photo.appendChild(el('span', 'oracura-related__badge', `${pct}% ${saleSuffix || ''}`.trim()));
      }
      link.appendChild(photo);

      const meta = el('span', 'oracura-related__meta');
      meta.appendChild(el('span', 'oracura-related__name', rec.title));
      const prices = el('span', 'oracura-related__prices');
      // Sold at more than one price: "From" before the lowest.
      if (rec.price_varies && fromLabel) prices.appendChild(el('span', 'oracura-related__from', fromLabel));
      prices.appendChild(el('span', 'oracura-related__now', brandRelatedMoney(rec.price)));
      if (onSale) {
        prices.appendChild(
          el('s', 'oracura-related__mrp', `${mrpLabel || 'MRP'} ${brandRelatedMoney(rec.compare_at_price)}`),
        );
      }
      meta.appendChild(prices);
      link.appendChild(meta);
      card.appendChild(link);

      const variant = (rec.variants || []).find((v) => v.available) || (rec.variants || [])[0];
      if (variant) {
        const btn = el('button', 'oracura-related__add');
        btn.type = 'button';
        btn.dataset.addVariant = variant.id;
        btn.disabled = !variant.available;
        btn.appendChild(
          el('span', 'oracura-related__add-text', variant.available ? addLabel || 'Add To Bag' : soldoutLabel || 'Sold out'),
        );
        card.appendChild(btn);
      }
      return card;
    };

    const shell = root.querySelector('[data-recs-fallback]');
    if (shell) {
      const row = shell.querySelector('[data-recs-row]');
      const pid = shell.dataset.productId;
      const limit = Number(shell.dataset.recsLimit) || 3;
      // The backup cards drawn by Liquid stay unless real recommendations
      // come back; either way the row then gets its arrows.
      const settle = () => { if (row.children.length) { shell.hidden = false; setupArrows(row); } };
      if (row && pid) {
        const base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        fetch(`${base}recommendations/products.json?product_id=${pid}&limit=10&intent=related`)
          .then((res) => (res.ok ? res.json() : null))
          .then((data) => {
            // The theme's "never suggest" list, applied here as well, since
            // this path builds its cards in the browser rather than in Liquid;
            // and never a product that cannot be bought.
            const never = root.dataset.neverSuggest || '';
            const keep = ((data && data.products) || [])
              .filter((rec) => rec.available && String(rec.id) !== String(pid) && !never.includes(`|${rec.handle}|`))
              .slice(0, limit);
            if (keep.length) row.replaceChildren(...keep.map(buildCard));
            settle();
          })
          .catch(settle);
      } else if (row) settle();
    }

  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oracura-product-reviews"] && !Shopify.designMode) return;
  try {
    
  /**
   * Review photos.
   *
   * A card showing "2" with no way to reach the second picture is a dead end, so
   * the frame steps through them on click. The photos are all in the markup with
   * CSS showing the first, which is what a visitor sees if this never runs.
   */
  const stepPhotos = (scope) => {
    for (const frame of scope.querySelectorAll('[data-review-photos]:not(.is-stepping)')) {
      const shots = [...frame.querySelectorAll('.oracura-pdp__review-photo-img')];
      if (shots.length < 2) continue;

      let at = 0;
      // Marks the frame so the stylesheet stops falling back to "show the first
      // one" and follows is-current instead.
      frame.classList.add('is-stepping');
      shots[0].classList.add('is-current');

      frame.addEventListener('click', () => {
        shots[at].classList.remove('is-current');
        at = (at + 1) % shots.length;
        shots[at].classList.add('is-current');
        frame.setAttribute(
          'aria-label',
          `Customer photo ${at + 1} of ${shots.length}. Show the next photo.`
        );
      });
    }
  };
  stepPhotos(document);

  /**
   * A review longer than its card scrolls inside it. The cut line was the only
   * sign of that (a phone hides its scrollbar at rest), so the text fades out
   * at the card's foot while there is more below, and stops fading at the end.
   * Watched for size, so it follows the row, the View All grid and new cards.
   */
  const markClip = (el) => {
    const more = el.scrollHeight - el.clientHeight > 2;
    el.classList.toggle('is-clipped', more);
    el.classList.toggle('is-end', more && el.scrollTop + el.clientHeight >= el.scrollHeight - 2);
  };
  const clipWatch = 'ResizeObserver' in window ? new ResizeObserver((entries) => {
    for (const { target } of entries) markClip(target);
  }) : null;
  const watched = new WeakSet();
  const watchTexts = (scope) => {
    for (const el of scope.querySelectorAll('.oracura-pdp__review-text')) {
      if (watched.has(el)) continue;
      watched.add(el);
      el.addEventListener('scroll', () => markClip(el), { passive: true });
      if (clipWatch) clipWatch.observe(el);
      else markClip(el);
    }
  };
  watchTexts(document);


  /**
   * Judge.me. Our Write a review presses the button in its hidden widget, so a
   * review goes through its own form. Reviews past the first page (the
   * metafield the cards were drawn from holds five) are fetched from its public
   * endpoint and drawn as the same cards, eighty at a time: when View All is
   * first opened, and then on "Load more reviews". Never on page load, where
   * a product with hundreds of reviews would fetch them all on every visit.
   */
  for (const root of document.querySelectorAll('.oracura-reviews[data-jm-product]')) {
    const ours = root.querySelector('[data-jm-write]');
    const app = root.querySelector('[data-reviews-app]');
    const theirs = () =>
      app && [...app.querySelectorAll('button, a')].find((b) => /write a review/i.test(b.textContent));
    if (ours && app) {
      const ready = () => {
        if (!theirs()) return false;
        ours.hidden = false;
        return true;
      };
      if (!ready()) {
        const watch = new MutationObserver(() => {
          if (ready()) watch.disconnect();
        });
        watch.observe(app, { childList: true, subtree: true });
      }
      ours.addEventListener('click', () => {
        const button = theirs();
        if (button) button.click();
      });
    }

    const list = root.querySelector('[data-reviews-list]');
    // Judge.me's count less the hidden reviews (see oracura-judgeme-score).
    const total = Number(root.dataset.jmCount) || 0;
    const more = root.querySelector('[data-jm-more]');
    const seen = new Set([...root.querySelectorAll('[data-review-card][data-jm-id]')].map((c) => c.dataset.jmId));
    if (!list) continue;

    // Reviews the store has hidden (Theme settings > Reviews > Hidden reviews):
    // never drawn, and taken off the totals on the tabs and star filters.
    const csv = (v) => String(v || '').split(',').map((t) => t.trim());
    const hiddenIds = csv(root.dataset.jmHidden);
    const hiddenRatings = csv(root.dataset.jmHiddenRatings).map(Number);
    const hiddenPhotos = csv(root.dataset.jmHiddenPhotos).map(Number);
    const hidden = new Set(hiddenIds.filter(Boolean));
    const hiddenAt = (rating) => hiddenIds.filter((id, i) => id && hiddenRatings[i] === rating).length;

    const icons = root.querySelector('template[data-jm-icons]');
    const icon = (name) => icons?.content.querySelector('[data-icon="' + name + '"]')?.innerHTML || '';
    const esc = (t) => String(t ?? '').replace(/[&<>"']/g, (c) => '&#' + c.charCodeAt(0) + ';');
    const text = (el) => (el ? el.textContent.replace(/\s+/g, ' ').trim() : '');

    // The same markup as snippets/oracura-review-card.liquid.
    const card = (rev) => {
      const rating = Number(rev.querySelector('[data-score]')?.dataset.score) || 0;
      const when = rev.querySelector('time[datetime]')?.getAttribute('datetime') || '';
      // Read in India time: Judge.me keeps a date-only review at midnight IST, which
      // is the evening before in UTC and would show a day early elsewhere.
      const date = when
        ? new Date(when).toLocaleDateString('en-US', { month: 'short', day: '2-digit', year: 'numeric', timeZone: 'Asia/Kolkata' })
        : '';
      const title = text(rev.querySelector('.jdgm-rev__title'));
      const body = text(rev.querySelector('.jdgm-rev__body'));
      const words = title ? title + ' – ' + body : body;
      const author = text(rev.querySelector('.jdgm-rev__author'));
      const verified = rev.dataset.verifiedBuyer === 'true';
      const variant = text(rev.querySelector('.jdgm-rev__variant-value'));
      const photos = [...rev.querySelectorAll('.jdgm-rev__pics [data-mfp-src]')]
        .slice(0, 3)
        .map((a) => a.dataset.mfpSrc.replace('width=1024', 'width=320'));

      const stars = [1, 2, 3, 4, 5]
        .map((i) => `<span class="oracura-pdp__review-star${i > rating ? ' is-empty' : ''}">${icon('star')}</span>`)
        .join('');
      const who =
        (author ? `<span class="oracura-pdp__review-author">${esc(author)}</span>` : '') +
        (verified ? `<span class="oracura-pdp__review-verified">${icon('seal-check')}Verified Buyer</span>` : '');
      const imgs = photos
        .map(
          (src) =>
            `<img class="oracura-pdp__review-photo-img" src="${esc(src)}" alt="Photo from a customer review" loading="lazy" width="320" height="320">`
        )
        .join('');

      let aside = '';
      if (photos.length > 1) {
        aside = `<div class="oracura-pdp__review-aside"><button type="button" class="oracura-pdp__review-photo button-unstyled" data-review-photos aria-label="Customer photo 1 of ${photos.length}. Show the next photo.">${imgs}<span class="oracura-pdp__review-photo-count" aria-hidden="true">${photos.length}</span></button>${who}</div>`;
      } else if (photos.length === 1) {
        aside = `<div class="oracura-pdp__review-aside"><span class="oracura-pdp__review-photo">${imgs}</span>${who}</div>`;
      } else if (who) {
        aside = `<div class="oracura-pdp__review-aside oracura-pdp__review-aside--nophoto">${who}</div>`;
      }

      return (
        `<article class="oracura-pdp__review-card" data-review-card data-jm data-jm-id="${esc(rev.dataset.reviewId)}" data-rating="${rating}" data-photos="${photos.length}">` +
        `<div class="oracura-pdp__review-top"><div class="oracura-pdp__review-stars" role="img" aria-label="${rating} out of 5 stars">${stars}</div>` +
        (date ? `<span class="oracura-pdp__review-date">${esc(date)}</span>` : '') +
        `</div>` +
        (words ? `<p class="oracura-pdp__review-text">${esc(words)}</p>` : '') +
        `<div class="oracura-pdp__review-body"><div class="oracura-pdp__review-main">` +
        (variant ? `<span class="oracura-pdp__review-variant">${esc(variant)}</span>` : '') +
        `</div>${aside}</div></article>`
      );
    };

    /*
     * View All browses every review, not only the ones already drawn. The tabs
     * and star chips show Judge.me's own totals, and each choice reads its own
     * listing from Judge.me: all reviews, a star filter (4+ is the fives and the
     * fours merged newest first), or the photo reviews (its pictures-first
     * order, up to the first review without one). Eighty at a time; Judge.me
     * hands out thirty per request, so a batch is up to three requests.
     */
    if (total <= seen.size) continue;
    root.setAttribute('data-jm-live', '');
    const PAGE = 30;
    const BATCH = 80;
    const shop = encodeURIComponent(root.dataset.jmShop);
    const product = encodeURIComponent(root.dataset.jmProduct);
    const fetchPage = async (params, page) => {
      const response = await fetch(
        'https://api.judge.me/reviews/reviews_for_widget?legacy_widget=true&platform=shopify' +
          `&per_page=${PAGE}&page=${page}&url=${shop}&shop_domain=${shop}&product_id=${product}${params}`
      );
      if (!response.ok) throw new Error(String(response.status));
      const data = await response.json();
      return {
        revs: [...new DOMParser().parseFromString(data.html || '', 'text/html').querySelectorAll('.jdgm-rev')],
        total: Number(data.total_count) || 0,
      };
    };
    const hasPhotos = (rev) => !!rev.querySelector('.jdgm-rev__pics [data-mfp-src]');
    const when = (rev) => Date.parse(rev.querySelector('time[datetime]')?.getAttribute('datetime') || '') || 0;
    const ratingOf = (rev) => Number(rev.querySelector('[data-score]')?.dataset.score) || 0;

    // One Judge.me listing, read a page at a time into a buffer. A listing
    // given `after` is a second reading of the same reviews in another order:
    // it waits until those listings have run out, then adds only what they
    // never reached.
    const listing = (params, photosOnly = false, after = null) => ({
      params, photosOnly, after, page: 1, buf: [], done: false, ids: new Set(), total: null, extra: 0, dry: 0,
    });
    const fill = async (l) => {
      if (l.done || l.buf.length) return;
      if (l.after) {
        if (!l.after.every((a) => a.done)) return;
        // Everything the first reading counted has been reached: stop here.
        const first = l.after[0];
        const reached = l.after.reduce((n, a) => n + (a === first ? a.ids.size : a.extra), 0) + l.extra;
        if (first.total !== null && reached >= first.total) {
          l.done = true;
          return;
        }
      }
      const { revs, total } = await fetchPage(l.params, l.page);
      l.page += 1;
      if (l.total === null) l.total = total;
      let fresh = 0;
      let added = 0;
      for (const rev of revs) {
        if (l.photosOnly && !hasPhotos(rev)) {
          l.done = true;
          break;
        }
        // Pages overlap (the imported reviews share one timestamp, which is
        // what Judge.me sorts by), so a review can come round again.
        const id = rev.dataset.reviewId;
        if (l.ids.has(id)) continue;
        l.ids.add(id);
        fresh += 1;
        if (l.after && l.after.some((a) => a.ids.has(id))) continue;
        added += 1;
        if (l.after) l.extra += 1;
        if (!hidden.has(id)) l.buf.push(rev);
      }
      // Judge.me leaves some reviews out of a page, so a short page is not the
      // last one; only an empty page is. Past about a thousand reviews it hands
      // back the same page over and over, so a page with nothing new is the end
      // too — otherwise "Load more" would fetch forever.
      if (!revs.length || (!fresh && !l.done)) l.done = true;
      // A second reading has met the first once two pages in a row bring
      // nothing the first did not already have.
      if (l.after) {
        l.dry = added ? 0 : l.dry + 1;
        if (l.dry >= 2) l.done = true;
      }
    };
    // The next n reviews across one or more listings, newest first.
    const take = async (listings, n, keep) => {
      const out = [];
      while (out.length < n) {
        await Promise.all(listings.map(fill));
        const ready = listings.filter((l) => l.buf.length);
        if (!ready.length) {
          // A second reading may only now be free to start.
          if (listings.every((l) => l.done)) break;
          continue;
        }
        ready.sort((a, b) => when(b.buf[0]) - when(a.buf[0]));
        const rev = ready[0].buf.shift();
        if (keep(rev)) out.push(rev);
      }
      return out;
    };

    const tabs = [...root.querySelectorAll('[data-reviews-tab]')];
    const chips = [...root.querySelectorAll('[data-reviews-min]')];
    const empty = root.querySelector('[data-reviews-empty]');
    let original = [...list.children];
    const state = { tab: 'all', min: 0 };
    let view = null;

    // Hidden reviews left the row short of the reviews Judge.me's metafield
    // holds (on the OC150 three of its five). Its first page fills the row
    // back up to that many — one request, and only on such a product.
    const skipped = Number(root.dataset.jmSkipped) || 0;
    const want = Number(root.dataset.jmFirst) || 0;
    if (skipped > 0 && want > seen.size) {
      (async () => {
        const top = listing('');
        const add = [];
        while (seen.size + add.length < want && !top.done) {
          await fill(top);
          for (const rev of top.buf.splice(0)) {
            if (seen.has(rev.dataset.reviewId) || seen.size + add.length >= want) continue;
            add.push(rev);
          }
        }
        // View All took the list over while this loaded: leave it alone.
        if (!add.length || view) return;
        for (const rev of add) seen.add(rev.dataset.reviewId);
        if (more && more.parentElement === list) more.insertAdjacentHTML('beforebegin', add.map(card).join(''));
        else list.insertAdjacentHTML('beforeend', add.map(card).join(''));
        stepPhotos(list);
        watchTexts(list);
        original = [...list.children];
        root.dispatchEvent(new CustomEvent('oracura:reviews-changed'));
      })().catch(() => {});
    }

    // Newest first. The reviews Judge.me prints into the page are its
    // pictures-first selection (2023 ahead of 2026), so its first page in its
    // own order, newest first, is read once and the row is sorted by date:
    // this year's reviews lead. The printed ones stay if the request fails.
    if (!view) {
      // The page already arrives newest first (review_widget_data above), so the row shows at
      // once; what this brings in is sorted in behind the newest. is-sorting is no longer set by
      // the theme; reveal() stays for the call below.
      const reveal = () => root.classList.remove('is-sorting');
      (async () => {
        const top = listing('');
        await fill(top);
        if (view) return;
        const add = top.buf.splice(0).filter((rev) => !seen.has(rev.dataset.reviewId));
        for (const rev of add) seen.add(rev.dataset.reviewId);
        if (add.length) list.insertAdjacentHTML('afterbegin', add.map(card).join(''));
        const dateOf = (c) => Date.parse(c.querySelector('.oracura-pdp__review-date')?.textContent || '') || 0;
        const anchor = more && more.parentElement === list ? more : null;
        [...list.querySelectorAll(':scope > [data-review-card]')]
          .sort((a, b) => dateOf(b) - dateOf(a))
          .forEach((c) => list.insertBefore(c, anchor));
        const row = root.querySelector('[data-reviews-row]');
        if (row) row.scrollLeft = 0;
        stepPhotos(list);
        watchTexts(list);
        original = [...list.children];
        root.dispatchEvent(new CustomEvent('oracura:reviews-changed'));
      })().catch(() => {}).finally(reveal);
    }

    // Totals: two requests per star. Judge.me's own count of the reviews at
    // that star, and of those with pictures (its with_pictures listing): the
    // true numbers, less the reviews the store has hidden. Reading the photo
    // reviews through to count them stopped where Judge.me's paging dropped
    // reviews, and said 125 where there are 177.
    const hiddenPhotosAt = (rating) =>
      hiddenIds.filter((id, i) => id && hiddenRatings[i] === rating && hiddenPhotos[i] > 0).length;
    let counts = null;
    let counting = null;
    const loadCounts = () =>
      (counting ||= (async () => {
        const byRating = {};
        const photosByRating = {};
        await Promise.all(
          [5, 4, 3, 2, 1].map(async (r) => {
            const [all, pics] = await Promise.all([
              fetchPage('&filter_rating=' + r, 1),
              fetchPage('&filter_rating=' + r + '&sort_by=with_pictures', 1),
            ]);
            byRating[r] = Math.max(0, all.total - hiddenAt(r));
            photosByRating[r] = Math.max(0, pics.total - hiddenPhotosAt(r));
          })
        );
        counts = { byRating, photosByRating };
      })().catch(() => {
        counting = null;
      }));
    const countFor = (tab, min) => {
      if (!counts) return null;
      // A chip shows exactly its own star; no chip pressed (0) means every review.
      const by = tab === 'photos' ? counts.photosByRating : counts.byRating;
      return [1, 2, 3, 4, 5].filter((r) => !min || r === min).reduce((sum, r) => sum + (by[r] || 0), 0);
    };
    const setCount = (el, n) => {
      const slot = el.querySelector('[data-reviews-count]');
      if (!slot || n === null) return;
      slot.textContent = n.toLocaleString('en-IN');
      slot.hidden = false;
    };
    const paintCounts = () => {
      if (!counts) return;
      for (const t of tabs) {
        const n = countFor(t.dataset.reviewsTab, state.min);
        setCount(t, n);
        // "With Images (0)" opened an empty panel: not offered at all, unless
        // it is the tab already open.
        if (t.dataset.reviewsTab === 'photos') t.hidden = n === 0 && t.getAttribute('aria-selected') !== 'true';
      }
      for (const chip of chips) {
        const n = countFor(state.tab, Number(chip.dataset.reviewsMin) || 0);
        setCount(chip, n);
        // Every star from 5 to 1 is offered, at 0 too (Jignesh, 21 Oct 2026).
        chip.hidden = false;
      }
    };

    /*
     * Judge.me's listings end early: past about a thousand reviews, and
     * wherever the imported reviews share a timestamp, its pages drop and
     * repeat reviews, so "All Reviews (1,735)" ran out at 961. Each star is
     * read on its own instead, newest first, then oldest first to reach what
     * the first reading could not; "All" merges the five, newest first. That
     * reaches about 98% (OC150 1,714 of 1,748, OC200 911 of 925, every review
     * on a smaller product). The photo reviews are read the same way, from
     * Judge.me's with-pictures listing per star and then its pictures-first
     * order.
     */
    const listingsFor = (tab, min) => {
      const stars = min ? [min] : [5, 4, 3, 2, 1];
      // A star with no reviews (once the totals are in) costs no request.
      const live = stars.filter((r) => !counts || countFor(tab, r) > 0);
      return live.flatMap((r) => {
        const star = '&filter_rating=' + r;
        if (tab === 'photos') {
          // Not stopped at a review without a photo: a video-only one may be
          // among these. The view leaves those out instead.
          const first = listing(star + '&sort_by=with_pictures');
          return [first, listing(star + '&sort_by=pictures_first', true, [first])];
        }
        const first = listing(star);
        return [first, listing(star + '&sort_dir=asc', false, [first])];
      });
    };

    const loadBatch = async () => {
      const v = view;
      if (!v || v.done || v.busy) return;
      v.busy = true;
      if (more) more.disabled = true;
      let revs = [];
      let failed = false;
      try {
        revs = await take(v.listings, BATCH, v.keep);
      } catch (error) {
        failed = true;
      }
      v.busy = false;
      // The shopper changed the filter (or closed View All) while this loaded.
      if (v !== view) return;
      if (!failed && revs.length < BATCH) v.done = true;
      const html = revs.map(card).join('');
      if (more && more.parentElement === list) more.insertAdjacentHTML('beforebegin', html);
      else list.insertAdjacentHTML('beforeend', html);
      v.shown += revs.length;
      if (empty) empty.hidden = v.shown > 0 || failed || Boolean(list.querySelector('[data-jw-mine]'));
      if (more) {
        more.disabled = false;
        more.hidden = v.done;
      }
      stepPhotos(list);
      watchTexts(list);
    };

    const showView = () => {
      const min = state.min;
      const photosOnly = state.tab === 'photos';
      const sigs = new Set();
      const keep = (rev) => {
        if (min && ratingOf(rev) !== min) return false;
        if (photosOnly && !hasPhotos(rev)) return false;
        const sig = [
          text(rev.querySelector('.jdgm-rev__author')),
          (rev.querySelector('time[datetime]')?.getAttribute('datetime') || '').slice(0, 10),
          text(rev.querySelector('.jdgm-rev__title')),
          text(rev.querySelector('.jdgm-rev__body')),
        ].join('|');
        if (sigs.has(sig)) return false;
        sigs.add(sig);
        return true;
      };
      view = {
        listings: listingsFor(state.tab, min),
        keep,
        shown: 0,
        done: false,
        busy: false,
      };
      list.replaceChildren();
      if (more) {
        list.append(more);
        more.hidden = true;
      }
      if (empty) empty.hidden = true;
      // The shopper's own review (assets/oracura-jm-write.js) goes back on top of the new list.
      root.dispatchEvent(new CustomEvent('oracura:reviews-view', { detail: { tab: state.tab, min: state.min } }));
      loadBatch();
    };

    if (more) more.addEventListener('click', loadBatch);
    for (const t of tabs) {
      t.addEventListener('click', () => {
        state.tab = t.dataset.reviewsTab;
        showView();
        setTimeout(paintCounts);
      });
    }
    for (const chip of chips) {
      chip.addEventListener('click', () => {
        const wasActive = chip.getAttribute('aria-pressed') === 'true';
        state.min = wasActive ? 0 : Number(chip.dataset.reviewsMin) || 0;
        showView();
        setTimeout(paintCounts);
      });
    }

    const opener = root.querySelector('[data-reviews-open]');
    const dialog = root.querySelector('[data-reviews-dialog]');
    if (opener) {
      opener.addEventListener('click', () => {
        state.tab = 'all';
        state.min = 0;
        showView();
        loadCounts().then(paintCounts);
      });
    }
    // Closing puts the page's own cards back before the row takes the list home.
    if (dialog) {
      dialog.addEventListener('close', () => {
        view = null;
        list.replaceChildren(...original);
        if (more) {
          more.hidden = true;
          list.append(more);
        }
        if (empty) empty.hidden = true;
        // `original` was taken before the shopper's own card was put on top; it goes back too.
        root.dispatchEvent(new CustomEvent('oracura:reviews-changed'));
      });
    }
  }

  /**
   * View All, and the tabs and star filters inside it.
   *
   * The page shows a row of reviews that swipes. "View All" moves that same
   * element into a dialog, where it becomes a filterable grid, and moves it
   * back on close — one copy of the cards, so the two views cannot disagree.
   *
   * The filters narrow the cards already on the page rather than fetching a
   * second set, so switching is instant and works offline. Each card carries
   * its own rating and photo count as data attributes, decided once in the card
   * snippet rather than re-derived from the rendered stars here.
   *
   * Everything degrades to the swipe row: if this never runs, "View All" stays
   * hidden and every review is still there to swipe through. That is the right
   * failure — showing all of them is never wrong; showing none would be.
   */
  for (const controls of document.querySelectorAll('[data-reviews-controls]')) {
    // Scoped to this section, not the first match in the document. Two review
    // sections on one page used to leave the second one's controls inert.
    const root = controls.closest('.oracura-reviews') || document;
    const list = root.querySelector('[data-reviews-list]');
    if (!list) continue;

    const empty = root.querySelector('[data-reviews-empty]');
    let cards = [...list.querySelectorAll('[data-review-card]')];
    const tabs = [...controls.querySelectorAll('[data-reviews-tab]')];
    const chips = [...controls.querySelectorAll('[data-reviews-min]')];
    if (!cards.length) continue;

    const row = root.querySelector('[data-reviews-row]');
    const dialog = root.querySelector('[data-reviews-dialog]');
    const slot = root.querySelector('[data-reviews-slot]');
    const openBtn = root.querySelector('[data-reviews-open]');
    const prevBtn = root.querySelector('[data-reviews-prev]');
    const nextBtn = root.querySelector('[data-reviews-next]');

    let tab = 'all';
    let minRating = 0;

    const matches = (card, forTab, forStar) =>
      (forTab !== 'photos' || Number(card.dataset.photos) > 0) &&
      (!forStar || (Number(card.dataset.rating) || 0) === forStar);

    // Every control says how many reviews it would leave. Without it a filter
    // that changes nothing is indistinguishable from a filter that is broken:
    // on a product rated only 4 and 5, ">2" and "4+" both keep everything, and
    // clicking them looks like nothing happened.
    const setCount = (el, n) => {
      const slot = el.querySelector('[data-reviews-count]');
      if (!slot) return;
      slot.textContent = n;
      slot.hidden = false;
    };

    const apply = () => {
      // A section browsing Judge.me live counts and filters itself (above).
      if (root.hasAttribute('data-jm-live')) return;
      // Read afresh: the shopper's own card is put in and taken out after the list is first read.
      cards = [...list.querySelectorAll('[data-review-card]')];
      let shown = 0;
      for (const card of cards) {
        const keep = matches(card, tab, minRating);
        card.hidden = !keep;
        if (keep) shown += 1;
      }
      if (empty) empty.hidden = shown > 0;

      for (const t of tabs) {
        const n = cards.filter((c) => matches(c, t.dataset.reviewsTab, minRating)).length;
        setCount(t, n);
        if (t.dataset.reviewsTab === 'photos') t.hidden = n === 0 && t.getAttribute('aria-selected') !== 'true';
      }
      for (const chip of chips) {
        const min = Number(chip.dataset.reviewsMin) || 0;
        const n = cards.filter((c) => matches(c, tab, min)).length;
        setCount(chip, n);
        // Every star from 5 to 1 is offered, at 0 too.
        chip.hidden = false;
      }
    };

    for (const t of tabs) {
      t.addEventListener('click', () => {
        tab = t.dataset.reviewsTab;
        for (const other of tabs) {
          const on = other === t;
          other.classList.toggle('is-active', on);
          other.setAttribute('aria-selected', String(on));
        }
        apply();
      });
    }

    for (const chip of chips) {
      chip.addEventListener('click', () => {
        // Toggle, not a radio: tapping the active chip clears it and returns to
        // every review, so there is a way back without an "all" chip.
        const wasActive = chip.getAttribute('aria-pressed') === 'true';
        minRating = wasActive ? 0 : Number(chip.dataset.reviewsMin) || 0;
        for (const other of chips) {
          other.setAttribute('aria-pressed', String(!wasActive && other === chip));
        }
        apply();
      });
    }

    // One card plus the gap, read off the rendered card rather than assumed, so
    // the step stays right as the card resizes across breakpoints.
    const step = () => {
      const card = list.querySelector('[data-review-card]');
      const gap = parseFloat(getComputedStyle(list).columnGap) || 0;
      return card ? card.getBoundingClientRect().width + gap : list.clientWidth * 0.8;
    };

    // Shown only while the row is on the page and actually overflows: a control
    // that cannot move anything is worse than no control. Disabled at each end
    // rather than hidden, so the pair does not jump about as you scroll.
    const syncArrows = () => {
      if (!prevBtn || !nextBtn) return;
      const inRow = list.dataset.reviewsMode === 'row';
      const max = list.scrollWidth - list.clientWidth;
      const usable = inRow && max > 2;
      prevBtn.hidden = !usable;
      nextBtn.hidden = !usable;
      if (!usable) return;
      prevBtn.disabled = list.scrollLeft <= 1;
      nextBtn.disabled = list.scrollLeft >= max - 1;
    };

    if (prevBtn && nextBtn) {
      prevBtn.addEventListener('click', () => list.scrollBy({ left: -step(), behavior: 'smooth' }));
      nextBtn.addEventListener('click', () => list.scrollBy({ left: step(), behavior: 'smooth' }));
      list.addEventListener('scroll', syncArrows, { passive: true });
      window.addEventListener('resize', syncArrows);
    }

    // Nothing below works without the dialog, so the button only appears once
    // there is something for it to open.
    if (dialog && slot && row && openBtn && typeof dialog.showModal === 'function') {
      openBtn.hidden = false;

      openBtn.addEventListener('click', () => {
        slot.append(list);
        list.dataset.reviewsMode = 'grid';
        dialog.showModal();
        syncArrows();
        apply();
      });

      const restore = () => {
        // Put the list back before anything else: it is the page's only copy of
        // the reviews, and a dialog that closes while holding it leaves the row
        // empty. Filters reset with it, so the row always shows every review.
        row.append(list);
        list.dataset.reviewsMode = 'row';
        list.scrollTo({ left: 0 });
        tab = 'all';
        minRating = 0;
        for (const t of tabs) {
          const on = t.dataset.reviewsTab === 'all';
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', String(on));
        }
        for (const chip of chips) chip.setAttribute('aria-pressed', 'false');
        syncArrows();
        apply();
      };

      for (const btn of root.querySelectorAll('[data-reviews-close]')) {
        btn.addEventListener('click', () => dialog.close());
      }
      // Covers Escape and the close button alike, so the list comes home
      // however the dialog was dismissed.
      dialog.addEventListener('close', restore);
      // A click on the backdrop lands on the dialog itself, never on its contents.
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      });
    }

    apply();
    syncArrows();

    // More cards arrived (Judge.me's later pages): filter and count them too.
    root.addEventListener('oracura:reviews-changed', () => {
      cards = [...list.querySelectorAll('[data-review-card]')];
      apply();
      syncArrows();
    });
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oracura-shop-drawer"]) return;
  try {
    
  const drawerBundleLink = document.querySelector('[data-oracura-drawer-bundle]');
  const drawerBundleTheme = window.Shopify?.theme;
  if (drawerBundleLink && drawerBundleTheme?.role !== 'main' && Number(drawerBundleTheme?.id)) {
    const drawerBundleUrl = new URL(drawerBundleLink.href);
    drawerBundleUrl.searchParams.set('preview_theme_id', drawerBundleTheme.id);
    drawerBundleLink.href = drawerBundleUrl.href;
  }

  } catch(e) { console.error(e); }
})();
})();
